import Api from './index'
import { IPayment } from '../models/payment'

export const getPayments = () => Api<IPayment[]>('GET', 'invoices/overview')
